import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export enum ShippingClaimEventType {
  CREATED = "created",
  STATUS_CHANGED = "status_changed",
  PHOTOS_ADDED = "photos_added",
  FILED_WITH_CARRIER = "filed_with_carrier",
  REFUND_ISSUED = "refund_issued",
}

const BaseShippingClaimEventSchema = z.object({
  createdAt: z.date(),
  userId: zExt.objectId().nullish(),
});

const CreatedEventSchema = BaseShippingClaimEventSchema.extend({
  type: z.literal(ShippingClaimEventType.CREATED),
  status: z.string(),
  proactive: z.boolean().nullish(),
});

const StatusChangedEventSchema = BaseShippingClaimEventSchema.extend({
  type: z.literal(ShippingClaimEventType.STATUS_CHANGED),
  fromStatus: z.string(),
  toStatus: z.string(),
});

const PhotosAddedEventSchema = BaseShippingClaimEventSchema.extend({
  type: z.literal(ShippingClaimEventType.PHOTOS_ADDED),
  photoCount: z.number(),
});

const FiledWithCarrierEventSchema = BaseShippingClaimEventSchema.extend({
  type: z.literal(ShippingClaimEventType.FILED_WITH_CARRIER),
  carrierClaimNumber: z.string().nullish(),
  carrier: z.string().nullish(),
});

const RefundIssuedEventSchema = BaseShippingClaimEventSchema.extend({
  type: z.literal(ShippingClaimEventType.REFUND_ISSUED),
  merchantRefundAmount: z.string().nullish(),
});

export const ShippingClaimEventSchema = z.discriminatedUnion("type", [
  CreatedEventSchema,
  StatusChangedEventSchema,
  PhotosAddedEventSchema,
  FiledWithCarrierEventSchema,
  RefundIssuedEventSchema,
]);

export type ShippingClaimEvent = z.infer<typeof ShippingClaimEventSchema>;
